<script>
/* eslint-disable */
/* tslint:disable */
import { createDokaComponent } from '../utils/createDoka.js';
export default createDokaComponent({
    name: 'DokaModal',
    render() { return null }
});
</script>